import { render, staticRenderFns } from "./FormatList.vue?vue&type=template&id=12e892a1&scoped=true&"
import script from "./FormatList.vue?vue&type=script&lang=js&"
export * from "./FormatList.vue?vue&type=script&lang=js&"
import style0 from "./FormatList.vue?vue&type=style&index=0&id=12e892a1&scoped=true&lang=css&"
import style1 from "./FormatList.vue?vue&type=style&index=1&id=12e892a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e892a1",
  null
  
)

export default component.exports